import { USER_GROUPS } from 'constants/userGroups';

export function getShortName(name) {
	if (!name) return '';
	const parts = name.split(' ');
	if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
	return parts.map((part) => part.charAt(0).toUpperCase()).join('');
}

export function getAvatarColor(name = '') {
	const colors = [
		'#007BFF', // Blue (Figma primary)
		'#A330ED', // Purple (Figma)
		'#00DFA8', // Teal/Green (Figma)
		'#FF8A00', // Orange
		'#2563EB', // Royal Blue
		'#7C3AED', // Violet
		'#059669', // Emerald
		'#D97706', // Amber
		'#DC2626', // Red
		'#4F46E5', // Indigo
		'#0891B2', // Cyan
		'#DB2777', // Pink
	];

	if (!name || typeof name !== 'string') {
		return colors[0];
	}

	// Deterministic string hash algorithm
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = (hash << 5) - hash + name.charCodeAt(i);
		hash |= 0; // Convert to 32bit integer
	}

	const index = Math.abs(hash) % colors.length;
	return colors[index];
}

// Map numeric user_group codes to plan labels
export const PLANS_BY_USER_GROUP = {
	[USER_GROUPS.MEMBER]: 'Member',
	[USER_GROUPS.ADMIN]: 'Admin',
	[USER_GROUPS.CLIENT]: 'Client',
	[USER_GROUPS.EMPLOYEE]: 'Employee',
};

export function getPlanByUserGroup(userGroup) {
	if (!userGroup) return null;
	return PLANS_BY_USER_GROUP[userGroup] || null;
}

export function isAdminUser(user) {
	return getPlanByUserGroup(user?.user_group) === 'Admin';
}

// Violerts-internal admin/employee (for onboarding filters, etc.)
export function isViolertsAdminUser(user) {
	const group = user?.user_group;
	return group === USER_GROUPS.ADMIN || group === USER_GROUPS.EMPLOYEE;
}
